// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.closeable-handle {
    cursor: pointer;
    z-index: 10;
    touch-action: manipulation;
    margin-bottom: 6px;
    display: inline-block;  
    position: absolute;
    top: -3px;
    right: 2px;
    font-size: 14px;
    margin: 3px;
}

.close-icon {
    line-height:32px !important;
    margin:auto;
    display:block;
}

.app-icon, .dashboard-icon {
    font-size: 30px;
    border-radius: 3px;
    padding: 3px;
    margin: 5px;
    text-align:center;
    cursor: pointer;
    height: 48px;
    width: 48px;
    color: var(--theme-text-color) !important;
}

.app-icon:hover {
    box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, 0.46);
}

.app-icon-text {
    font-size: 10px;
    color: var(--theme-text-color) !important;
}

.app-icon-open, .app-icon-open:hover {
    box-shadow: inset 0 0 3px 0.5px rgba(0, 0, 0, 0.46);
}

.app-parent {
    padding-top: 24px;
}

.app-icon-closeable-handle {
    font-size: 15px;
    position: absolute;
    right: 3px;
}

.app-title {
	position: absolute;
	z-index: 12;
	font-size: 12px;
	height: 0;
	overflow: visible;
	pointer-events: none;
	text-align: center;
	width: 100%;
	top: 4px;
}

.main-content {
    min-height: 0;
    min-height: initial;
    min-width: 0;
    min-width: initial;
}

.morphle-watermark {
    bottom: 16px;
    height: 48px;
    left: 16px;
    position: absolute;
    z-index: 2;
    opacity: 0.6;
    visibility: hidden;
    display: none;
}

.morphle-watermark-visible {
    visibility: visible !important;
    display: block !important;
    z-index: 999999;
}

.full-parent {
	height: 100%;
	width: 100%;
}

.full-parent-imp {
    height: 100% !important;
    width: 100% !important;
}

.max-parent {
	max-width: 100%;
	max-height: 100%;
}

.min-content {
	height: -webkit-min-content;
	height: min-content;
	width: -webkit-min-content;
	width: min-content;
}

.full-width {
	width: 100%;
}

.full-height {
	height: 100%;
}

.flex-center {
	display: flex;
	align-items: center;
	justify-content: center;
}

.ant-spin-container {
	height: inherit;
	width: inherit;
}

.customTooltip {
    box-sizing: content-box;
    position: absolute;
    visibility: visible;
    background-color: #fff;
    min-width: 950px;
    max-width: 3300px;
    border-radius: 5px;
    box-shadow: 0 3px 30px rgba(33,33,33,.3);
    transition: opacity .1s ease-out;
  }

.purple-radio-group > .ant-radio-button-wrapper-checked {
    border-color: rgb(112,11,128) !important ;
    color: rgb(112,11,128) !important;
}

.purple-radio-group > .ant-radio-button-wrapper:hover {
    color: rgb(112,11,128) !important;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/utils/app.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,SAAS;CACT,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;CAClB,WAAW;CACX,QAAQ;AACT;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,mBAAmB;CACnB,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;EAClC;;AAEF;IACI,yCAAyC;IACzC,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".closeable-handle {\n    cursor: pointer;\n    z-index: 10;\n    touch-action: manipulation;\n    margin-bottom: 6px;\n    display: inline-block;  \n    position: absolute;\n    top: -3px;\n    right: 2px;\n    font-size: 14px;\n    margin: 3px;\n}\n\n.close-icon {\n    line-height:32px !important;\n    margin:auto;\n    display:block;\n}\n\n.app-icon, .dashboard-icon {\n    font-size: 30px;\n    border-radius: 3px;\n    padding: 3px;\n    margin: 5px;\n    text-align:center;\n    cursor: pointer;\n    height: 48px;\n    width: 48px;\n    color: var(--theme-text-color) !important;\n}\n\n.app-icon:hover {\n    box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, 0.46);\n}\n\n.app-icon-text {\n    font-size: 10px;\n    color: var(--theme-text-color) !important;\n}\n\n.app-icon-open, .app-icon-open:hover {\n    box-shadow: inset 0 0 3px 0.5px rgba(0, 0, 0, 0.46);\n}\n\n.app-parent {\n    padding-top: 24px;\n}\n\n.app-icon-closeable-handle {\n    font-size: 15px;\n    position: absolute;\n    right: 3px;\n}\n\n.app-title {\n\tposition: absolute;\n\tz-index: 12;\n\tfont-size: 12px;\n\theight: 0;\n\toverflow: visible;\n\tpointer-events: none;\n\ttext-align: center;\n\twidth: 100%;\n\ttop: 4px;\n}\n\n.main-content {\n    min-height: 0;\n    min-height: initial;\n    min-width: 0;\n    min-width: initial;\n}\n\n.morphle-watermark {\n    bottom: 16px;\n    height: 48px;\n    left: 16px;\n    position: absolute;\n    z-index: 2;\n    opacity: 0.6;\n    visibility: hidden;\n    display: none;\n}\n\n.morphle-watermark-visible {\n    visibility: visible !important;\n    display: block !important;\n    z-index: 999999;\n}\n\n.full-parent {\n\theight: 100%;\n\twidth: 100%;\n}\n\n.full-parent-imp {\n    height: 100% !important;\n    width: 100% !important;\n}\n\n.max-parent {\n\tmax-width: 100%;\n\tmax-height: 100%;\n}\n\n.min-content {\n\theight: -webkit-min-content;\n\theight: min-content;\n\twidth: -webkit-min-content;\n\twidth: min-content;\n}\n\n.full-width {\n\twidth: 100%;\n}\n\n.full-height {\n\theight: 100%;\n}\n\n.flex-center {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.ant-spin-container {\n\theight: inherit;\n\twidth: inherit;\n}\n\n.customTooltip {\n    box-sizing: content-box;\n    position: absolute;\n    visibility: visible;\n    background-color: #fff;\n    min-width: 950px;\n    max-width: 3300px;\n    border-radius: 5px;\n    box-shadow: 0 3px 30px rgba(33,33,33,.3);\n    transition: opacity .1s ease-out;\n  }\n\n.purple-radio-group > .ant-radio-button-wrapper-checked {\n    border-color: rgb(112,11,128) !important ;\n    color: rgb(112,11,128) !important;\n}\n\n.purple-radio-group > .ant-radio-button-wrapper:hover {\n    color: rgb(112,11,128) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
